import { Component } from '@angular/core';

@Component({
  selector: 'app-header',
  templateUrl: './app-header.component.html'
})
export class AppHeaderComponent { }



// WEBPACK FOOTER //
// /app/src/app/components/app-header/app-header.component.ts